import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import Icon from "components/icon";
import styles from "./styles/download-icon.css.js";
import IconButton from "components/icon-button";
import withStyles from "components/with-styles";

const DownloadIcon = ({compactStyle, classes, disabled, disabledClass}) => {
    return (
        <>
            {compactStyle ? (
                <Icon
                    className={cn(classes.compact, {[disabledClass || classes.icon__disabled]: disabled})}
                    name="cloud-download"
                />
            ) : (
                <IconButton disabled={disabled}>
                    <Icon className={cn({[disabledClass || classes.icon__disabled]: disabled})} name="cloud-download"/>
                </IconButton>
            )}
        </>
    );
};

DownloadIcon.propTypes = {
    /**
     * Muestra estilos compactos
     **/
    compactStyle: PropTypes.bool,
    /**
     * Muestra el mensaje con los estilos deshabilitados
     **/
    disabled: PropTypes.bool,
    /**
     * Reemplaza la clase de deshabilitado por defecto
     **/
    disabledClass: PropTypes.string,
};

export default withStyles(styles)(DownloadIcon);
